import React from 'react';
import { NavLink } from 'react-router-dom';

const SidebarAdmin = () => {
  return (
    <div className="d-flex flex-md-column justify-content-between sidebar-admin bg-dark border-end border-secondary shadow-lg">

      {/* 👑 LOGO / TITRE (Visible uniquement sur ordinateur) */}
      <div className="sidebar-brand p-3 d-none d-md-block text-center border-bottom border-secondary border-opacity-25">
        <h5 className="text-warning fw-semibold mb-0 mt-2 text-uppercase tracking-wider" style={{ fontSize: '1rem' }}>
          👑 Administration
        </h5>
      </div>

      {/* 🧭 NAVIGATION PRINCIPALE */}
      <nav className="nav flex-row flex-md-column w-100 px-2 py-1 py-md-3 justify-content-around justify-content-md-start gap-1 gap-md-2">

        {/* 🏠 ONGLET ACCUEIL / CAPITALES */}
        <NavLink
          to="/admin"
          exact
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Général'
          activeClassName="active-admin"
        >
          <i className="material-icons">grid_view</i>
          <span className="ms-md-3 small-md fw-semibold">Général</span>
        </NavLink>

        {/* 📊 ONGLET FINANCES */}
        <NavLink
          to="/compte"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Finances'
          activeClassName="active-admin"
        >
          <i className="material-icons">account_balance_wallet</i>
          <span className="ms-md-3 small-md fw-semibold">Finances</span>
        </NavLink>

        {/* 🎮 ONGLET CULTURE & QUIZ */}
        <NavLink
          to="/culture"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Culture'
          activeClassName="active-admin"
        >
          <i className="material-icons">theater_comedy</i>
          <span className="ms-md-3 small-md fw-semibold">Culture</span>
        </NavLink>

        {/* 🎮 ONGLET TOTAL BATTLE */}
        <NavLink
          to="/compteur"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Minuteur'
          activeClassName="active-admin"
        >
          <i className="material-icons">shield</i>
          <span className="ms-md-3 small-md fw-semibold">TotalBattle</span>
        </NavLink>

        {/* 🎮 ONGLET TOTAL BATTLE */}
        <NavLink
          to="/minuteur"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Minuteur'
          activeClassName="active-admin"
        >
          <i className="material-icons">hourglass_full</i>
          <span className="ms-md-3 small-md fw-semibold">Minuteur</span>
        </NavLink>

      </nav>

      {/* 👤 DISCRET RAPPEL BAS (Visible uniquement sur ordinateur) */}
      <div className="p-3 d-none d-md-block border-top border-secondary border-opacity-25 text-center text-light small">
        ⚡ v2.0
      </div>

    </div>
  );
};

export default SidebarAdmin;
